// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyVideoDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.676 19.968a.25.25 0 0 1 0 .354l-.354.354a.25.25 0 0 1-.353 0l-2.302-2.301A3 3 0 0 1 14 20H4a3 3 0 0 1-3-3V7a3 3 0 0 1 1.626-2.667l-1.45-1.45a.25.25 0 0 1 0-.353l.354-.353a.25.25 0 0 1 .354 0zM15 16.709 4.293 6H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zm0-5.622V7a1 1 0 0 0-1-1H7.271l-2-2H14a3 3 0 0 1 3 3v.942l1.663-1.801C20.207 4.468 23 5.56 23 7.836v8.328c0 1.758-1.669 2.81-3.14 2.425L15 13.73v-.816zm2 1.828a.5.5 0 0 0 .133.339l3 3.25a.5.5 0 0 0 .867-.34V7.837a.5.5 0 0 0-.867-.339l-3 3.25a.5.5 0 0 0-.133.34z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyVideoDisabled;
